import { render, staticRenderFns } from "./DetailTablePayment.vue?vue&type=template&id=ff63be6a"
import script from "./DetailTablePayment.vue?vue&type=script&lang=js"
export * from "./DetailTablePayment.vue?vue&type=script&lang=js"
import style0 from "./DetailTablePayment.vue?vue&type=style&index=0&id=ff63be6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports